import React, { Component } from "react";
import { CompanyReviewService } from "../../service/CompanyReviewService";
import TokenHandler from "../../auth/TokenHandler";
import { Button } from "primereact/button";
import { ROLES } from "../../utils/RoleConstants";
import { Dialog } from "primereact/dialog";
import { DateHandler } from "../../utils/DateHandler";

class CompanyReview extends Component {
    constructor(props) {
        super(props);
        this.state = {
          isJobSeeker: false,
          companyId: null,
          reviews: [],
          addReviewDialog:false,
          reviewNote:''
        };

        this.companyReviewService = new CompanyReviewService();
        this.tokenHandler = new TokenHandler();
    }

    componentDidMount() {
      let isAuthenticated = this.tokenHandler.isLoggedIn();
      const roles = this.tokenHandler.getUserRoles();
      if (isAuthenticated && (roles.length>0 && roles[0] === ROLES.JOB_SEEKER)) {
        this.setState({isJobSeeker: true});
      }
      this.onLoadReviews();
    }

    onLoadReviews =()=> {
      let { reviews, companyId } = this.state;
      const { company } = this.props;
      if (!company) {
        return;
      }

      this.companyReviewService.loadAllActiveReviews(company)
      .then((res) => {
        if (res.status === 200) {
          return res.json().then(body => {
            reviews = body;
            companyId = company;

            this.setState({reviews, companyId});
          })
        }
      })
    }

    addNewReviewClick =()=> {
      const {companyId, reviewNote, addReviewDialog } = this.state;
      
      let req = {
        companyId: companyId,
        note: reviewNote
      }

      this.companyReviewService.addNewReview(req)
      .then((res) => {
        if (res.status === 200) {
          addReviewDialog = false;
          reviewNote = '';
          this.setState({reviewNote, addReviewDialog});
        }
      })
    }
    render() {
        const { reviews, isJobSeeker, addReviewDialog, reviewNote } = this.state;
        return (
          <div className="col-12 pt--20 pt_lg--20 pd0">
            { isJobSeeker && 
              <div className="col-md-12 text-right pr-0">
                <Button label="Add your review" onClick={() => this.setState({addReviewDialog:true})}/>
              </div>
            }
            {reviews.map((review, i) => {
              return (
                <div
                  className="col-md-12 pd0"
                  key={i}
                >
                  <div className="job-item text-lg-left">
                    <div className="job-content p-1">
                      <h5 className="title" style={{ margin: "0px" }}>
                        {review.reviewer}
                      </h5>
                      <small >{DateHandler.getDateFromStringAnyFormat(review.reviewDate, "YYYY-MM-DD HH:mm:ss")}</small>
                      <div className="meta-job pd0">
                        <span className="meta-content" dangerouslySetInnerHTML={{ __html: review.reviewNote }}>
                        </span>
                      </div>
                      
                    </div>
                  </div>
                </div>
              );
            })}

            <Dialog header={'Review details'} modal visible={addReviewDialog}
            onHide={() => this.setState({addReviewDialog:false})}
            footer={
              <Button label="Add review" icon="pi pi-plus"
                  onClick={this.addNewReviewClick}
                />
            }>
              <div className="col-md-12">
                <label>Notes: </label><br/>
                <textarea value={reviewNote} rows={5} cols={30} placeholder="Enter review notes"
                onChange={(e) => this.setState({reviewNote: e.target.value})}/>
              </div>
            </Dialog>
          </div>
        );
      }
    }
    export default CompanyReview;